<template>
  <div>
    <van-tabbar :safe-area-inset-bottom="true" active-color="#28B86A" fixed route>
      <van-tabbar-item name="home" to="/home" replace>
        <span>{{ $t('tabbar.home') }}</span>
        <img
          slot="icon"
          slot-scope="props"
          :src="props.active ? homeIcon.active : homeIcon.inactive">
      </van-tabbar-item>
      <van-tabbar-item name="exam" to="/mine" replace>
        <span>{{ $t('tabbar.mine') }}</span>
        <img
          slot="icon"
          slot-scope="props"
          :src="props.active ? mineIcon.active : mineIcon.inactive">
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      homeIcon: {
        active: require('@/assets/tabbar/home-active.png'),
        inactive: require('@/assets/tabbar/home-inactive.png')
      },
      mineIcon: {
        active: require('@/assets/tabbar/mine-active.png'),
        inactive: require('@/assets/tabbar/mine-inactive.png')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.van-tabbar{
  height: 64px;
  box-shadow: 0px -1px 8px 0px rgba(23,159,142,0.3);
}
</style>



// WEBPACK FOOTER //
// src/layout/components/Tabbar/index.vue